import React from 'react';
import { Layout, Menu, Popconfirm } from 'antd';
import { UsergroupAddOutlined, LaptopOutlined, NotificationOutlined, MenuUnfoldOutlined, LogoutOutlined, MenuOutlined, UserOutlined  } from '@ant-design/icons';
import { Link, withRouter, RouteComponentProps } from 'react-router-dom';
import Amplify, { Auth } from "aws-amplify";
import logo from '../../assets/triangle.png'
import logo_expanded from '../../assets/new-logo-w.png'
import slugify from 'slugify';


const { SubMenu } = Menu;
const { Header, Content, Sider } = Layout;




const logout = () => {
  // let localForm = localStorage.getItem('form');
  // console.log(localForm)
  // if(localForm){
  //   return
  // }
  localStorage.removeItem("form");
  // localStorage.removeItem("user");
  // localStorage.removeItem("firstVisit");
  Auth.signOut().then((data) => {
    console.log(data)
    window.location.href='/'
  
    // window.location.reload(true)
  });
};



const MainSidebar=(props)=>{

  let activeMenuKey = '/';
  if(props.location && props.location.pathname){
    activeMenuKey = props.location.pathname
  }
 
    return(

      <Sider 
     
      // style={{background.theme1.accentColor}}
        theme="light"
        width={'200px'} 
        collapsible={true}
        collapsed={props.collapsed}
        className="main-sidebar"
        trigger={null}
        onCollapse={()=>{
            // console.log('clicked')
            // props.setCollapsed(!props.collapsed)
        }}
        >
        <Menu
         theme="dark"
          mode="inline"
          defaultSelectedKeys={[activeMenuKey]}
          style={{ 
            height: '100%', 
            borderRight: 0,
            paddingTop:'20px'
            // background.theme1.accentColor, 
            // color:'white' 
          }}
        >

          <Menu.Item key={'logo'} style={{padding:'0px'}}>
                      {props.collapsed == true ? 
                    <div style={{height:"40px", width:'40px', margin:'auto', display:'flex', justifyContent:'center', alignItems:'center'}}>
                      <img src={logo} style={{height:"auto", width:'100%'}}/>
                    </div>
                   :
                   <div style={{height:"auto",width:'120px', marginLeft:'11px'}}>
                      <img src={logo_expanded} style={{height:"auto",width:'100%'}}/>
                   </div> 
                      }
          </Menu.Item>
           <Menu.Item> 
                {/* <MenuOutlined
                  style={{ color: '#fff', fontSize: 15, display: 'inline-block', marginRight: 20 }}
                  onClick={() => {
                    props.setCollapsed(!props.collapsed)
                  }} /> */}
                  <MenuUnfoldOutlined 
                  style={{ color: '#fff', fontSize: '19px', display: 'inline-block', marginRight: 20 }}
                  onClick={() => {
                    props.setCollapsed(!props.collapsed)
                  }}/>
                  </Menu.Item>

          {props.menuS.map((p)=>{
            if(p.type == 'submenu'){
              return(
                <SubMenu
                  key={p.to}
                  title={
                    <>
                      {p.icon}
                    <span>
                   
                      {p.title}
                    </span>
                  </>
                  }
                >
                {p.children && 
                p.children.map((m)=>{
                  return(
                    <Menu.Item key={m.to}>
                      <LaptopOutlined/>

                      <Link to={m.to}>{m.title}</Link>
                    
                    </Menu.Item>
                  )
                })}
              </SubMenu>
              )
            }else{
              return(
                <Menu.Item  
                  id={slugify(p.title.trim() + "Menu", {
                     lower: true
                  })}
                  key={p.to}> 
                  <Link to={p.to ? p.to : '/'}>
                  {p.icon}
                  <span>

                 {p.title}
                  </span>
                  </Link>
                </Menu.Item>
              )
            }
          })}

           
            <Menu.Item  
            onClick={()=>{
              }}
            
                  key={'logout'}> 
                    <Popconfirm placement="topLeft" title={<><p style={{fontSize:'12px',color:'grey',margin:'5px'}}>Please make sure all your changes are saved, on logout unsaved form changes will be deleted, </p><p style={{fontSize:'12px',color:'grey', margin:'5px'}}>Are you sure to logout ?</p></>} onConfirm={logout} okText="Yes" cancelText="No">
                    <span className="anticon">
                    <LogoutOutlined style={{fontSize:16,marginRight:0}}/>
                    </span>
                    <span>Logout</span>
            </Popconfirm>
              
                </Menu.Item> 
         
        </Menu>
      </Sider>


);
}

// IMP - PLEASE MAKE SURE THAT USE MEMO IS CHECKING ALL REQUIRED PROPS FOR CHANGE/UPDATE
function equalityCheckForProps(prevProps, nextProps) {
  return prevProps.menuS.length === nextProps.menuS.length && prevProps.collapsed == nextProps.collapsed
}

export default withRouter(React.memo(MainSidebar,equalityCheckForProps))

